import type { ReactNode } from "react";
import InfoTooltip from "#/components/ui/InfoTooltip";

interface ReportSectionProps {
  title: string;
  subtitle?: ReactNode;
  children: ReactNode;
  rightSection?: ReactNode;
  tooltip?: ReactNode;
}

const ReportSection = ({ title, subtitle, children, rightSection, tooltip }: ReportSectionProps) => {
  return (
    <div className="flex h-full flex-col gap-4 rounded-xl border border-gray-200 bg-white p-6">
      <div className="flex items-center justify-between">
        <div className="flex flex-col gap-0.5">
          <div className="flex items-center gap-2">
            <h3 className="text-base font-semibold text-gray-900">{title}</h3>
            {tooltip && <InfoTooltip content={tooltip} />}
          </div>
          {subtitle && <div className="flex flex-col gap-0.5 text-xs text-gray-500">{subtitle}</div>}
        </div>
        {rightSection && <div>{rightSection}</div>}
      </div>
      {children}
    </div>
  );
};

export default ReportSection;
